import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const getUserData: TypedDocumentNode<Pick<GQL.IQuery, "me">> = gql`
    query getUserData {
        me {
            id
            email
            isAdmin
            isAdminWrite
            is2faEnabled
            companies {
                id
                name
                datevNrConsultant
                datevNrCompany
            }
        }
    }
`;

export const getPrivateToken: TypedDocumentNode<Pick<GQL.IQuery, "privateToken">, GQL.IQueryPrivateTokenArgs> = gql`
    query getPrivateToken($code: String!) {
        privateToken(code: $code) {
            token
        }
    }
`;

export const getCompanyAccessData: TypedDocumentNode<Pick<GQL.IQuery, "company">, GQL.IQueryCompanyArgs> = gql`
    query getCompanyAccessData($id: ID!) {
        company(id: $id) {
            id
            name
            color
            favouritePaymentType
            datevNrConsultant
            datevNrCompany
            accountingYears
            legalForm
            legalName
            invoiceName
            invoiceEmail
            invoiceReceiver
            invoiceAddress {
                addressLine2
                city
                countryCode
                house
                postCode
                street
            }
            invoiceTax {
                bundesland
                stnr
            }
            invoiceVat {
                countryCode
                vatNumber
            }
            invoiceRegister {
                type
                court
                number
            }
            invoiceHeadquarter
            invoiceGeneralPartnerName
            invoiceGeneralPartnerInvoiceRegister {
                type
                court
                number
            }
            director
            IBAN
            BIC
            bankName
            avvAccepted
            owner {
                id
                email
            }
            bankList {
                id
                year
                name
                accountNum
                isFavorite
            }
            kasseList {
                id
                year
                name
                accountNum
                isFavorite
            }
            members {
                id
                emailKey
                roles
                products {
                    id
                    productKey
                    access
                }
            }
            products {
                id
                productKey
            }
            accountingConfigs {
                id
                skr
                kontoExt
                taxation
                year
                fiscalYearStart
                ustvaFrequency
                dauerfristverlaengerung
                steuerlichBeraten
            }
            datevOAuth {
                id
                issuedAt
                accessTokenExpiresIn
                refreshTokenExpiresIn
            }
            logo
            isLocked
        }
    }
`;

export const getDmsDocumentTypes: TypedDocumentNode<Pick<GQL.IQuery, "dmsTypes">, GQL.IQueryDmsTypesArgs> = gql`
    query getDmsDocumentTypes($companyId: ID!) {
        dmsTypes(companyId: $companyId) {
            id
            icon
            subTypes {
                id
                name
                sortOrder
                icon
                dmsDocumentTypeId
                bankId
                kbId
                bankingBankId
                cashRegisterId
            }
        }
    }
`;

export const getDocumentAccountingRecordsLookup: TypedDocumentNode<
    Pick<GQL.IQuery, "documentAccountingRecordsLookup">,
    GQL.IQueryDocumentAccountingRecordsLookupArgs
> = gql`
    query getDocumentAccountingRecordsLookup($companyId: ID!, $documentId: ID!) {
        documentAccountingRecordsLookup(companyId: $companyId, documentId: $documentId) {
            id
            recordId
            year
            groupId
            productKey
        }
    }
`;

export const getGenericRecordsLookup: TypedDocumentNode<
    Pick<GQL.IQuery, "genericRecordsLookup">,
    GQL.IQueryGenericRecordsLookupArgs
> = gql`
    query getGenericRecordsLookup($input: IDsCompanyIDInput!) {
        genericRecordsLookup(input: $input) {
            id
            recordId
            year
            groupId
            productKey
        }
    }
`;

export const getGenericRecordsDocuments: TypedDocumentNode<
    Pick<GQL.IQuery, "genericRecordsDocuments">,
    GQL.IQueryGenericRecordsDocumentsArgs
> = gql`
    query getGenericRecordsDocuments($input: IDsCompanyIDInput!) {
        genericRecordsDocuments(input: $input) {
            id
            documents {
                id
            }
        }
    }
`;

export const datevUserInfoQuery: TypedDocumentNode<Pick<GQL.IQuery, "datevUserInfo">> = gql`
    query datevUserInfo {
        datevUserInfo {
            user {
                id
                name
                email
                familyName
                emailVerified
            }
            clients {
                id
                clientNumber
                consultantNumber
                name
                services {
                    name
                    scopes
                }
            }
        }
    }
`;
